import { useMemo } from 'react';
import { mvs } from 'react-native-size-matters';

import { useAppSelector } from '../app/hooks';
import { IS_WEB, isTablet, REDUCED_HORIZONTAL_MARGIN } from '../constants';
import { selectHasMargin } from '../features/appconfig/store/selectors';

/**
 * custom hook for responsive layout calculations
 * returns appropriate padding and max width based on margin settings
 */
export function useResponsiveLayout() {
  const hasMargin = useAppSelector(selectHasMargin);

  const bodyHorizontalPadding = hasMargin ? mvs(32) : REDUCED_HORIZONTAL_MARGIN;

  const maxWidth = useMemo(() => {
    if (isTablet || !hasMargin) {
      return '100%' as const;
    }
    return IS_WEB ? 300 : mvs(450);
  }, [hasMargin]);

  return { bodyHorizontalPadding, maxWidth };
}
